// ---------------------------------------------------------------------------
// InputGroupListV3 — renderiza uma lista de ``InputGroupCardV3``.
// ---------------------------------------------------------------------------
// Extraido do monolito ``InputsV3.js`` (leva 57-K). Recebe uma lista
// de grupos ({id, title, inputs, displayResponsibleName?}) e e
// **totalmente controlado** pelo pai quanto a quais grupos estao
// abertos: o pai passa ``openIds`` (Set<string>) + ``onToggle(id)``.
//
// Regras (user feedback 2026-04-24):
//   - **Nenhum grupo precisa estar aberto.** E valido o estado "todos
//     fechados" — inicializa assim por padrao.
//   - **Multiplos grupos podem estar abertos simultaneamente.** Nao
//     e accordion no sentido estrito; clicar em um nao fecha os
//     demais.
//   - O pai costuma oferecer um toggle "abrir/fechar todos" ao lado
//     dos botoes de ordenacao, implementado usando ``onToggle``
//     replicado ou substituindo diretamente o proprio ``openIds``
//     quando o pai mantem o state.
// ---------------------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";

import InputGroupCardV3 from "./InputGroupCardV3";

const InputGroupListV3 = ({
  groups,
  openIds,
  onToggle,
  onInputClick,
  clientColor,
  onInputFileDrop,
  onDropReject,
}) => {
  if (groups.length === 0) return null;
  // ``openIds`` pode ser Set ou Array — aceitamos ambos por
  // conveniencia (o pai pode guardar como Set e espalhar com [...Set]
  // quando persistir em memoization).
  const isOpen = (id) => {
    if (!openIds) return false;
    if (openIds instanceof Set) return openIds.has(id);
    return Array.isArray(openIds) && openIds.includes(id);
  };
  return groups.map((g) => (
    <InputGroupCardV3
      key={g.id}
      title={g.title}
      inputs={g.inputs}
      isOpen={isOpen(g.id)}
      onToggle={() => onToggle(g.id)}
      onInputClick={onInputClick}
      clientColor={clientColor}
      displayResponsibleName={g.displayResponsibleName}
      onInputFileDrop={onInputFileDrop}
      onDropReject={onDropReject}
    />
  ));
};

InputGroupListV3.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.node.isRequired,
      inputs: PropTypes.array.isRequired,
      displayResponsibleName: PropTypes.string,
    }),
  ).isRequired,
  openIds: PropTypes.oneOfType([
    PropTypes.instanceOf(Set),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onToggle: PropTypes.func.isRequired,
  onInputClick: PropTypes.func,
  clientColor: PropTypes.string.isRequired,
  onInputFileDrop: PropTypes.func,
  onDropReject: PropTypes.func,
};

export default InputGroupListV3;
